/* HEXA x The Block garages article.
   Loaded with defer, so the DOM is parsed by the time this runs.
   Three jobs: scroll reveal, lazy video, FAQ accordion. */
(function () {
  'use strict';

  var root = document.querySelector('.hxg-blk');
  if (!root) return;

  /* ---- scroll reveal ---------------------------------------------------- */
  var reveals = root.querySelectorAll('[data-rv]');

  if (!('IntersectionObserver' in window)) {
    // No observer support: show everything rather than hide content.
    for (var i = 0; i < reveals.length; i++) reveals[i].classList.add('is-in');
  } else {
    var rvObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-in');
        rvObserver.unobserve(entry.target);
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.1 });

    reveals.forEach(function (el) { rvObserver.observe(el); });
  }

  /* ---- lazy video -------------------------------------------------------
     The source is held in data-src and only attached once the player scrolls
     into view. This keeps the MP4 off the critical path on mobile. */
  var video = root.querySelector('[data-lazy-video]');

  if (video) {
    var source = video.querySelector('source');
    var loaded = false;

    var attach = function () {
      if (loaded || !source || !source.dataset.src) return;
      source.src = source.dataset.src;
      video.load();
      loaded = true;
    };

    var play = function () {
      attach();
      video.muted = true;
      var attempt = video.play();
      if (attempt && attempt.catch) attempt.catch(function () { /* autoplay blocked, leave paused */ });
    };

    if ('IntersectionObserver' in window) {
      var vidObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) { play(); } else if (loaded) { video.pause(); }
        });
      }, { threshold: 0.35 });
      vidObserver.observe(video);
    }

    // Mute toggle
    var muteBtn = root.querySelector('[data-mute]');
    if (muteBtn) {
      var iconOn = muteBtn.querySelector('[data-icon-on]');
      var iconOff = muteBtn.querySelector('[data-icon-off]');

      var syncIcons = function () {
        if (!iconOn || !iconOff) return;
        iconOn.style.display = video.muted ? 'none' : '';
        iconOff.style.display = video.muted ? '' : 'none';
      };

      muteBtn.addEventListener('click', function () {
        attach();
        video.muted = !video.muted;
        if (!video.muted && video.paused) video.play().catch(function () {});
        syncIcons();
        muteBtn.setAttribute('aria-label', video.muted ? 'Unmute video' : 'Mute video');
      });

      syncIcons();
    }
  }

  /* ---- FAQ accordion ----------------------------------------------------- */
  root.querySelectorAll('.fq-q').forEach(function (button) {
    button.addEventListener('click', function () {
      var item = button.parentNode;
      var isOpen = item.classList.toggle('open');
      button.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
    });
  });
})();
